import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import model from './model';

export interface IContractorUpgrade extends IModel {
	description?: string;
	sellPrice?: number;
	upgradeType?: number;
}

const contractorUpgradeFactory = modelFactory.createFactory <IContractorUpgrade>('ContractorUpgrade', _.assign({}, model, {
	description: {
		rules: validator.string()
	},
	sellPrice: {
		setFilters: valueFilters.cleanNumber,
		getFilters: valueFilters.toNumber,
		rules: validator.required()
	},
	upgradeType: {
	}
}));

export default contractorUpgradeFactory;